if (window.CKEDITOR) {
	CKEDITOR.plugins.setLang( 'nbsp', 'en', {
    label: 'Add a non-breaking space',
	});
}
